import React from 'react'
import { useNavigate } from 'react-router-dom'

import { FormattedMessage } from '@divvy-web/i18n'
import { BannerType } from '@divvy-web/skylab.banner'
import TextLink, { TextLinkSizes } from '@divvy-web/skylab.textlink'

import useGetCreditAppTypes from '@sputnik/hooks/useGetCreditAppTypes'
import StatusBanner from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ActionsNeededSection/StatusBanner'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { logInfo } from '@sputnik/utils/loggerUtils'

interface ResumeApplicationBannerProps {
  salesforceCreditId: string
}

// This status shows if status is not_started or if in_progress without savedSections
const ResumeApplicationBanner = ({ salesforceCreditId }: ResumeApplicationBannerProps) => {
  const navigate = useNavigate()

  const { isAppVersion3, isLoadingCreditAppTypes } = useGetCreditAppTypes({
    salesforceCreditId: salesforceCreditId || '',
  })

  const onResumeApplicationClick = () => {
    logInfo('onResumeApplicationClick', {
      attributes: {
        creditAppId: salesforceCreditId,
        result: 'Clicked resume application from banner',
      },
      eventName: 'onResumeApplicationClick',
    })

    isAppVersion3
      ? navigate(`/app/${salesforceCreditId}/${PATHNAME_CONSTS.NAME_AND_OWNERSHIP_PATH}`)
      : navigate(`/app/${salesforceCreditId}/section/${PATHNAME_CONSTS.BUSINESS_INFO_PATH}`)
  }

  return (
    <div className='fs-unmask'>
      <StatusBanner
        bannerType={BannerType.Informative}
        subtext={
          <FormattedMessage
            defaultMessage="You're almost there! <link>Resume your application</link>"
            id='sputnik.ResumeApplicationBanner__dezVS5'
            values={{
              link: (chunks) => (
                <TextLink
                  disabled={isLoadingCreditAppTypes}
                  size={TextLinkSizes.SMALL}
                  onClick={onResumeApplicationClick}
                >
                  {chunks}
                </TextLink>
              ),
            }}
          />
        }
        title={
          <FormattedMessage
            defaultMessage='Resume application'
            id='sputnik.ResumeApplicationBanner__1JRfgv'
          />
        }
      />
    </div>
  )
}

export default ResumeApplicationBanner
